import { useTranslation } from 'react-i18next';

export default function Safety() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200">
          <div className="flex items-start gap-4 md:gap-6">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
              <i className="ri-shield-check-line text-2xl md:text-3xl" />
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                {t('safety_title')}
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4">
                {t('safety_desc')}
              </p>
              <div className="flex items-center gap-2 p-4 bg-white rounded-xl border border-background-200">
                <i className="ri-information-line text-accent-500 text-xl" />
                <p className="text-sm text-foreground-700 font-medium">
                  {t('safety_note')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}